import React, { useState } from "react"
import { Form, Col, Row } from "react-bootstrap"
import LampWidget from "../LampWidget"

import * as styles from "./Styles/Widget.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { WidgetProps } from "./types"

const sizes = { width: [], height: [] }
for (let i = 300; i <= 560; i += 5) {
  sizes.width.push({ label: `${i}px`, key: i })
}
for (let i = 250; i <= 500; i += 5) {
  sizes.height.push({ label: `${i}px`, key: i })
}

const Widget: React.FC<WidgetProps> = (props) => {
  const lamp = props.params.lamp
  const [width, setWidth] = useState("300")
  const [height, setHeight] = useState("250")
  const [displayName, setdisplayName] = useState(true)
  const [fullWidth, setFullWidth] = useState(false)

  const computeWidthParam = () => (fullWidth ? "" : `width="${width}"`)
  const computeIframeSrc = () =>
    `${props.params.url}?display_name=${displayName ? 1 : 0}&full_width=${
      fullWidth ? 1 : 0
    }&height=${height}${fullWidth ? "" : "&width=" + width}`
  const computeStyles = (type: string): object | string => {
    if (type == "string") {
      return fullWidth
        ? `height: ${height}px; width: 100%;`
        : `height: ${height}px; width: ${width}px;`
    }
    if (fullWidth) {
      return { height: `${height}px`, width: "100%" }
    }
    return { height: `${height}px`, width: `${width}px` }
  }

  return (
    <div className="l-section-background--admin">
      <Form noValidate>
        <div className={cn("l-flex", "sectionWrapper")}>
          <div className={styles.sectionLeft}>
            <Form.Label>表示サイズ</Form.Label>
          </div>
          <div className={styles.sectionRight}>
            <Row className={cn("l-flex-align-center", "sizeRow")}>
              <Col sm={2}>幅</Col>
              <Col sm={3}>
                <Form.Control
                  id="widgetForm.width"
                  as="select"
                  custom
                  onChange={(e) => setWidth(e.target.value)}
                  value={width}
                  disabled={fullWidth}
                >
                  {sizes.width.map((size) => (
                    <option key={size.key} value={size.key}>
                      {size.label}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col sm={2}>高さ</Col>
              <Col sm={3}>
                <Form.Control
                  id="widgetForm.height"
                  as="select"
                  custom
                  onChange={(e) => setHeight(e.target.value)}
                  value={height}
                >
                  {sizes.height.map((size) => (
                    <option key={size.key} value={size.key}>
                      {size.label}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
            <Row>
              <Form.Group controlId="widgetForm.fullWidth">
                <Col>
                  <Form.Check
                    type="checkbox"
                    label="幅を100%に固定"
                    onChange={(e) => setFullWidth(e.target.checked)}
                    checked={fullWidth}
                  />
                </Col>
              </Form.Group>
            </Row>
          </div>
        </div>
        <hr className={styles.separator} />
        <Form.Group controlId="widgetForm.displayName">
          <div className={cn("l-flex", "sectionWrapper")}>
            <div className={styles.sectionLeft}>
              <Form.Label>施設名</Form.Label>
            </div>
            <div className={styles.sectionRight}>
              <Form.Check
                type="checkbox"
                label="表示する"
                onChange={(e) => setdisplayName(e.target.checked)}
                checked={displayName}
              />
            </div>
          </div>
        </Form.Group>
        <hr className={styles.separator} />
        <Form.Group controlId="adminPlace.url">
          <div className={cn("l-flex", "sectionWrapper")}>
            <div className={styles.sectionLeft}>
              <Form.Label>バナーコード</Form.Label>
            </div>
            <div className={styles.sectionRight}>
              <Form.Control
                value={`<iframe frameborder="0" ${computeWidthParam()} height="${height}" scrolling="no" src="${computeIframeSrc()}" title="${
                  props.place.name
                }の混雑ランプ" style="${computeStyles(
                  "string"
                )}"><a href="${computeIframeSrc()}">${
                  props.place.name
                }の混雑ランプ</a></iframe>`}
                onClick={(e) => e.target.select()}
                readOnly
              />
            </div>
          </div>
        </Form.Group>
      </Form>
      <hr className={styles.separator} />
      <div className={cn("l-flex", "sectionWrapper")}>
        <div className={styles.sectionLeft}>
          <label>表示サンプル</label>
        </div>
        <div className={styles.sectionRight}>
          <LampWidget
            styles={{
              ...(computeStyles("object") as object),
              border: "1px solid black",
            }}
            displayName={displayName ? 1 : 0}
            place={props.place}
            lamp={lamp}
          />
        </div>
      </div>
      <div className={styles.annotation}>
        <span>
          混雑ランプサイト連携タグをご利用いただくことにより、以下の各事項に同意頂いたものとみなします。
        </span>
        <ul>
          <li>
            混雑ランプサイト連携タグは、ブラウザまたはウェブサーバの仕様または設定等によって、動作しない場合や、想定しない動作をする場合がございますが、弊社は、混雑ランプサイト連携タグの動作について、保証するものではありません。
          </li>
          <li>
            サーバのメンテナンス、ソフトウェアの不具合またはネットワークの障害その他の理由により、混雑ランプアプリ、混雑ランプ投稿ツールまたは混雑ランプ端末から送信された情報が反映されない場合がございます。
          </li>
          <li>
            弊社は、混雑ランプサイト連携タグの利用または利用不可に関して貴社が損害を被った場合であっても、当該損害を賠償する責任を負いません。
          </li>
          <li>
            弊社は、混雑ランプサイト連携タグの提供を予告なく中断または終了する場合がございます。
          </li>
        </ul>
      </div>
    </div>
  )
}
export default Widget
